module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/642f474eeb0475db500eb0a85076adde.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_4.svg
// module id = dj9Z
// module chunks = 0